import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const DotsVerticalIcon = forwardRef<SVGSVGElement, IconProps>(function LockIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 7.41177C8.17157 7.41177 7.5 8.12284 7.5 9C7.5 9.87716 8.17157 10.5882 9 10.5882C9.82843 10.5882 10.5 9.87716 10.5 9C10.5 8.12284 9.82843 7.41177 9 7.41177Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M9 14.8235C8.17157 14.8235 7.5 15.5346 7.5 16.4118C7.5 17.2889 8.17157 18 9 18C9.82843 18 10.5 17.2889 10.5 16.4118C10.5 15.5346 9.82843 14.8235 9 14.8235Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M9 0C8.17157 0 7.5 0.711077 7.5 1.58824C7.5 2.46539 8.17157 3.17647 9 3.17647C9.82843 3.17647 10.5 2.46539 10.5 1.58824C10.5 0.711077 9.82843 0 9 0Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
